// Libellé d'un profil d'accès (spec 159, FR-010) — source unique. Avant cette spec, l'en-tête affichait le code brut
// (« Reseller ») et deux écrans d'administration recopiaient chacun leur propre table.
import type { Role } from '../types/profile'

const ROLE_LABEL: Record<Role, string> = {
  Admin: 'Administrateur Pragmelis',
  Consultant: 'Consultant Pragmelis',
  Reseller: 'Revendeur',
  Client: 'Client',
}

/** Libellé français d'un rôle ; un code inconnu reste affiché tel quel plutôt que de disparaître. */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return ''
  return (ROLE_LABEL as Record<string, string>)[role] ?? role
}

// Forme courte, pour la barre du haut : la forme complète la faisait déborder à 1 366 px (relevé de l'incrément 3).
// Elle se lit en infobulle de la forme courte, et en entier dans les écrans d'administration.
const ROLE_LABEL_COURT: Record<Role, string> = {
  Admin: 'Administrateur',
  Consultant: 'Consultant',
  Reseller: 'Revendeur',
  Client: 'Client',
}

/** Libellé court d'un rôle (barre du haut) ; un code inconnu reste affiché tel quel. */
export function roleLabelCourt(role: string | null | undefined): string {
  if (!role) return ''
  return (ROLE_LABEL_COURT as Record<string, string>)[role] ?? role
}
